import {
  NewReleases,
  Phone,
  PhoneMissed,
  PhoneCallback,
  Schedule,
  EventAvailable,
  Payments,
  EmojiEvents,
  RemoveCircle,
  Replay,
  PauseCircle,
  AssignmentLate,
  Forum,
  ThumbUp,
  ThumbDown,
  HelpOutline,
  TrendingUp,
  TrendingDown,
  VisibilityOff,
  NotificationsNone,
  QuestionMark,
  LabelImportant,
  ErrorOutline,
  Block,
  Timer,
  AccessTime,
  EventBusy,
  EventNote,
  CallEnd,
  CallMade,
  CallReceived,
  CallSplit,
  Chat,
  ChatBubble,
  PersonOff,
  Security,
  AssignmentTurnedIn,
} from "@mui/icons-material";

export const PIPELINE_STAGE_CATALOG = [
  // Pre-Consultation Pipeline Stages
  {
    key: "qualified",
    label: "Qualified Leads",
    color: "#059669",
    icon: <AssignmentTurnedIn fontSize="small" />,
  },
  {
    key: "need_analysis",
    label: "Need Analysis",
    color: "#0EA5E9",
    icon: <HelpOutline fontSize="small" />,
  },
  {
    key: "booked",
    label: "Booked",
    color: "#067A2E",
    icon: <EventAvailable fontSize="small" />,
  },

  // Post-Consultation Pipeline Stages
  {
    key: "post_consult",
    label: "Post-Consult",
    color: "#7C3AED",
    icon: <AssignmentTurnedIn fontSize="small" />,
  },
  {
    key: "proposal_shared",
    label: "Proposal-Shared",
    color: "#0284C7",
    icon: <LabelImportant fontSize="small" />,
  },
  {
    key: "negotiation",
    label: "Negotiation",
    color: "#9333EA",
    icon: <Chat fontSize="small" />,
  },
  {
    key: "treatment_booked",
    label: "Treatment-Booked",
    color: "#EA580C",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    key: "won",
    label: "Won",
    color: "#15803D",
    icon: <EmojiEvents fontSize="small" />,
  },
  {
    key: "dropped",
    label: "Dropped",
    color: "#4B5563",
    icon: <RemoveCircle fontSize="small" />,
  },

  // Original Stages (kept for backward compatibility)
  {
    key: "new",
    label: "New",
    color: "#2563EB",
    icon: <NewReleases fontSize="small" />,
  },

  {
    key: "lead_received",
    label: "Lead Received",
    color: "#2563EB",
    icon: <NewReleases fontSize="small" />,
  },
  {
    key: "lead_assigned",
    label: "Lead Assigned",
    color: "#6366F1",
    icon: <LabelImportant fontSize="small" />,
  },
  {
    key: "lead_viewed",
    label: "Lead Viewed",
    color: "#64748B",
    icon: <VisibilityOff fontSize="small" />,
  },

  {
    key: "dialing",
    label: "Dialing",
    color: "#0EA5E9",
    icon: <CallMade fontSize="small" />,
  },
  {
    key: "ringing",
    label: "Ringing",
    color: "#38BDF8",
    icon: <NotificationsNone fontSize="small" />,
  },
  {
    key: "connected",
    label: "Connected",
    color: "#22C55E",
    icon: <Phone fontSize="small" />,
  },
  {
    key: "not_connected",
    label: "Not Connected",
    color: "#EF4444",
    icon: <PhoneMissed fontSize="small" />,
  },
  {
    key: "callback",
    label: "Callback",
    color: "#7C3AED",
    icon: <PhoneCallback fontSize="small" />,
  },
  {
    key: "busy",
    label: "Busy",
    color: "#6B7280",
    icon: <CallEnd fontSize="small" />,
  },
  {
    key: "switched_off",
    label: "Switched Off",
    color: "#9CA3AF",
    icon: <VisibilityOff fontSize="small" />,
  },
  {
    key: "voicemail",
    label: "Voicemail",
    color: "#64748B",
    icon: <CallReceived fontSize="small" />,
  },
  {
    key: "wrong_number",
    label: "Wrong Number",
    color: "#DC2626",
    icon: <CallSplit fontSize="small" />,
  },

  {
    key: "interested",
    label: "Interested",
    color: "#16A34A",
    icon: <ThumbUp fontSize="small" />,
  },
  {
    key: "not_interested",
    label: "Not Interested",
    color: "#9CA3AF",
    icon: <ThumbDown fontSize="small" />,
  },
  {
    key: "neutral",
    label: "Neutral",
    color: "#A1A1AA",
    icon: <HelpOutline fontSize="small" />,
  },
  {
    key: "high_intent",
    label: "High Intent",
    color: "#22C55E",
    icon: <TrendingUp fontSize="small" />,
  },
  {
    key: "low_intent",
    label: "Low Intent",
    color: "#9CA3AF",
    icon: <TrendingDown fontSize="small" />,
  },

  {
    key: "follow_up",
    label: "Follow Up",
    color: "#F97316",
    icon: <Schedule fontSize="small" />,
  },
  {
    key: "follow_up_later",
    label: "Follow Up Later",
    color: "#FB923C",
    icon: <Timer fontSize="small" />,
  },
  {
    key: "follow_up_missed",
    label: "Follow Up Missed",
    color: "#DC2626",
    icon: <AssignmentLate fontSize="small" />,
  },
  {
    key: "rescheduled",
    label: "Rescheduled",
    color: "#D97706",
    icon: <Replay fontSize="small" />,
  },
  {
    key: "waiting",
    label: "Waiting",
    color: "#FACC15",
    icon: <AccessTime fontSize="small" />,
  },
  {
    key: "on_hold",
    label: "On Hold",
    color: "#6B7280",
    icon: <PauseCircle fontSize="small" />,
  },

  {
    key: "discussion",
    label: "Discussion",
    color: "#6366F1",
    icon: <Forum fontSize="small" />,
  },
  {
    key: "proposal_shared",
    label: "Proposal Shared",
    color: "#0284C7",
    icon: <LabelImportant fontSize="small" />,
  },
  {
    key: "negotiation",
    label: "Negotiation",
    color: "#9333EA",
    icon: <Chat fontSize="small" />,
  },
  {
    key: "price_discussion",
    label: "Price Discussion",
    color: "#7C3AED",
    icon: <ChatBubble fontSize="small" />,
  },

  {
    key: "booking",
    label: "Booking",
    color: "#22C55E",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    key: "appointment_no_show",
    label: "No Show",
    color: "#9CA3AF",
    icon: <PersonOff fontSize="small" />,
  },

  {
    key: "payment_pending",
    label: "Payment Pending",
    color: "#F59E0B",
    icon: <Payments fontSize="small" />,
  },
  {
    key: "payment_received",
    label: "Payment Received",
    color: "#16A34A",
    icon: <Payments fontSize="small" />,
  },

  {
    key: "verification_failed",
    label: "Verification Failed",
    color: "#DC2626",
    icon: <ErrorOutline fontSize="small" />,
  },

  {
    key: "duplicate",
    label: "Duplicate",
    color: "#9CA3AF",
    icon: <Block fontSize="small" />,
  },
  {
    key: "invalid",
    label: "Invalid",
    color: "#6B7280",
    icon: <ErrorOutline fontSize="small" />,
  },
  {
    key: "spam",
    label: "Spam",
    color: "#991B1B",
    icon: <Block fontSize="small" />,
  },

  {
    key: "won",
    label: "Won",
    color: "#15803D",
    icon: <EmojiEvents fontSize="small" />,
  },
  {
    key: "dropped",
    label: "Dropped",
    color: "#4B5563",
    icon: <RemoveCircle fontSize="small" />,
  },
];

export const PIPELINE_STAGE_GROUPS = {
  // Pre-Consultation Pipeline Stages
  "Pre-Consult": ["qualified", "need_analysis", "booked", "dropped"],

  // Post-Consultation Pipeline Stages
  "Post-Consult": [
    "post_consult",
    "proposal_shared",
    "negotiation",
    "treatment_booked",
    "won",
    "dropped",
  ],

  "Lead Intake": ["new", "lead_received", "lead_assigned", "lead_viewed"],
  Calling: [
    "dialing",
    "ringing",
    "connected",
    "not_connected",
    "callback",
    "busy",
    "switched_off",
    "voicemail",
    "wrong_number",
  ],
  Interest: [
    "interested",
    "not_interested",
    "neutral",
    "high_intent",
    "low_intent",
  ],
  Followup: [
    "follow_up",
    "follow_up_later",
    "follow_up_missed",
    "rescheduled",
    "waiting",
    "on_hold",
  ],
  Discussion: [
    "discussion",
    "proposal_shared",
    "negotiation",
    "price_discussion",
  ],
  Booking: ["booking", "appointment_no_show"],
  Payment: ["payment_pending", "payment_received"],
  Validation: ["verification_failed"],
  Closure: ["won", "dropped"],
};

export const PIPELINE_STAGE_MAP = Object.fromEntries(
  PIPELINE_STAGE_CATALOG.map((s) => [s.key, s])
);

export const getPipelineStage = (key) =>
  PIPELINE_STAGE_MAP[key] || {
    key,
    label: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    color: "#6B7280",
    icon: <LabelImportant fontSize="small" />,
  };
